"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UalHamian = exports.UALHamianOption = void 0;
const universal_authenticator_library_1 = require("universal-authenticator-library");
const hamian_1 = __importDefault(require("hamian"));
const HamianUser_1 = require("./HamianUser");
const interfaces_1 = require("./interfaces");
const HamianLogo_1 = require("./HamianLogo");
class UALHamianOption {
    constructor() {
        this.appId = '';
    }
}
exports.UALHamianOption = UALHamianOption;
class UalHamian extends universal_authenticator_library_1.Authenticator {
    constructor(chains, config) {
        super(chains);
        this.users = [];
        this.error = "";
        this.config = config;
        if (!this.config.appId) {
            this.config.useChainId = true;
            this.config.appId = chains[0].chainId.substr(0, 20);
        }
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.hamian = new hamian_1.default(this.config.appId, this.config.serverUrl, this.config.botName, this.config.useChainId, this.config.appTitle);
            var profile = this.hamian.getprofile();
            if (profile) {
                this.users = [new HamianUser_1.UALHamianUser(profile, this.hamian)];
            }
            return;
        });
    }
    reset() {
        this.users = [];
    }
    isErrored() {
        return !!this.error;
    }
    getOnboardingLink() {
        return 'https://telegram.org/apps';
    }
    getError() {
        var message = this.error;
        this.error = "";
        return message;
    }
    isLoading() {
        return false;
    }
    getStyle() {
        return {
            icon: HamianLogo_1.HamianLogo,
            text: interfaces_1.Name,
            textColor: 'white',
            background: '#FFC107'
        };
    }
    shouldRender() {
        return !this.isLoading();
    }
    shouldAutoLogin() {
        return true;
    }
    shouldRequestAccountName() {
        return __awaiter(this, void 0, void 0, function* () {
            return false;
        });
    }
    login(accountName) {
        console.log('accountName', accountName);
        return new Promise((res, rej) => {
            this.hamian.login().then(() => {
                var user = this.hamian.getprofile();
                if (!user)
                    return rej();
                res([new HamianUser_1.UALHamianUser(user, this.hamian)]);
            })
                .catch((exp) => {
                if (exp.message)
                    this.error = exp.message;
                rej(exp);
            });
        });
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            this.hamian.logout();
            return;
        });
    }
    requiresGetKeyConfirmation() {
        return false;
    }
    getName() {
        return 'hamian';
    }
}
exports.UalHamian = UalHamian;
